import React from 'react';
import { connect } from 'react-redux';
import actions from './actions';

function WithButtonState(WrappedComponent) {
  const C = props => <WrappedComponent {...props} />;

  function mapStateToProps({ button }) {
    return {
      buttonState: button.buttonState,
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      setButtonState: state => dispatch(actions.setButtonState(state)),
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(C);
}

export default WithButtonState;



// WEBPACK FOOTER //
// ./src/features/Button/WithButtonState.js